import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MAIN_NAV_ITEMS } from '../../config';
import { useCategoryFromQuery, useThemeFromQuery } from '../../hooks/useQueryFilters';

function Header({ theme, onToggleTheme }) {
  const location = useLocation();
  const activeCategory = useCategoryFromQuery();
  const activeTheme = useThemeFromQuery();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const isNewsRoute = location.pathname === '/' || location.pathname.startsWith('/news');
  const navBasePath = location.pathname.startsWith('/news') ? '/news' : '/';

  useEffect(() => {
    // Close mobile menu on navigation
    setMobileNavOpen(false);
  }, [location.pathname, location.search]);

  const queryString = (cat) => {
    const params = new URLSearchParams();
    if (cat && cat !== 'All') {
      params.set('category', cat);
    }
    // When switching main category from the header, clear any theme filter
    // so users don't get "empty" lists accidentally.
    if (activeTheme) {
      params.delete('theme');
    }
    const search = params.toString();
    return search ? `?${search}` : '';
  };

  const todayLabel = new Date().toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <header className="site-header">
      <div className="site-header-top">
        <div className="site-header-top-inner">
          <div className="site-header-date">{todayLabel}</div>
          <div className="site-header-top-right">
            <span className="header-badge-small">Live, government-compliant data only</span>
          </div>
        </div>
      </div>

      <div className="site-header-main">
        <div className="site-header-inner">
          <div className="header-slot-left">
            {isNewsRoute && (
              <button
                type="button"
                className="mobile-nav-toggle"
                aria-label={mobileNavOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={mobileNavOpen}
                aria-controls="mobile-main-nav"
                onClick={() => setMobileNavOpen((v) => !v)}
              >
                <span aria-hidden="true">{mobileNavOpen ? '✕' : '☰'}</span>
              </button>
            )}
            
          </div>

          <Link to="/" className="brand brand-centered" aria-label="IGAMINGSPOT home">
            <div className="brand-text brand-text-only">
              <div className="brand-title brand-title-logo">IGAMINGSPOT</div>
              <div className="brand-subtitle">igamingspot.net · Regulated casino &amp; betting</div>
            </div>
          </Link>

          <div className="header-slot-right">
            <Link to="/tips" className="header-outline-button">
              Submit a tip
            </Link>
            <button
              type="button"
              className="theme-toggle"
              aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
              onClick={onToggleTheme}
            >
              <span className="theme-toggle-icon" aria-hidden="true">
                {theme === 'dark' ? '☀' : '☾'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isNewsRoute && (
        <nav
          id="mobile-main-nav"
          className={`site-header-nav ${mobileNavOpen ? 'open' : ''}`}
          aria-label="Main sections"
        >
          <div className="nav-list">
            {MAIN_NAV_ITEMS.map((item) => {
              const cat = item.category;
              const isActive =
                activeCategory === cat || (cat === 'All' && activeCategory === 'All');
              return (
                <Link
                  key={cat}
                  to={`${navBasePath}${queryString(cat)}`}
                  className={`top-nav-link ${isActive ? 'active' : ''}`}
                  onClick={() => setMobileNavOpen(false)}
                >
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </div>
        </nav>
      )}
    </header>
  );
}

export default Header;


